var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-profession-list-selector',{attrs:{"defaultSelectedProfessionCodes":_vm.defaultSelectedProfessionCodes},model:{value:(_vm.professionsSource),callback:function ($$v) {_vm.professionsSource=$$v},expression:"professionsSource"}})}
var staticRenderFns = []

export { render, staticRenderFns }